import { QuestionnaireComplete } from "./questionnaire-complete";
import { QuestionnaireFlowRoot } from "./questionnaire-context";
import {
	QuestionnaireChat,
	QuestionnaireDialogShell,
	QuestionnaireOptions,
	QuestionnaireProgress,
	QuestionnaireStep,
} from "./questionnaire-parts";

/**
 * Composition API for landing questionnaire paths (fund / payments / cash-flow).
 *
 * @example
 * ```tsx
 * <QuestionnaireFlow.Root path={path} onOpenChange={…} ctaHrefs={…}>
 *   <QuestionnaireFlow.Step>
 *     <QuestionnaireFlow.Chat />
 *     <QuestionnaireFlow.Options />
 *   </QuestionnaireFlow.Step>
 *   <QuestionnaireFlow.Progress />
 * </QuestionnaireFlow.Root>
 * ```
 */
export const QuestionnaireFlow = {
	Root: QuestionnaireFlowRoot,
	Dialog: QuestionnaireDialogShell,
	Step: QuestionnaireStep,
	Chat: QuestionnaireChat,
	Options: QuestionnaireOptions,
	Complete: QuestionnaireComplete,
	Progress: QuestionnaireProgress,
};
